<template>
    <div>
       <div v-show="!jjfaVisible">
        <div  style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">
            签约项目管理-详情
        </div>
        <el-button
            style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
            @click="Return">返回</el-button>
        <div style="height: 820px;overflow-y:scroll">
            <div
                style="height: 350px; background-color: #FFFFFF; margin: 0px 40px; margin-top: 9px; padding-top: 20px;">

                <div style="border-left: 3px #006E4B solid; height: 20px; width: 100%; margin-left: 30px;">
                    <span style="margin-left: 10px; font-size: 20px; line-height: 20px; font-weight: bold;">基础信息</span>
                </div>
                <hr style="margin-left: 30px; margin-right: 30px; margin-top: 20px; margin-bottom: 30px;" />

                <div style="width: 94%; margin: 0 3%;">
                    <table style="width: 100%;">
                        <tr style="height: 50px;">
                            <td style="text-align: right; width: 16%; color: #b6b6b6;">组织架构：</td>
                            <td colspan="3">{{$globals.group_name + '/' + form.organize_name}}</td>
                            <td style="text-align: right; width: 16%; color: #b6b6b6;">城市：</td>
                            <td style="width: 9%;">{{form.city}}</td>
                            <td style="text-align: right; width: 16%; color: #b6b6b6;">合同编码：</td>
                            <td style="width: 9%;">{{form.contract_code}}</td>
                        </tr>
                        <tr style="height: 50px;">
                            <td style="text-align: right; color: #b6b6b6;">甲方名头：</td>
                            <td>{{form.party_title}}</td>
                            <td style="text-align: right; color: #b6b6b6;">合同名称：</td>
                            <td>{{form.contract_name}}</td>
                            <td style="text-align: right; color: #b6b6b6;">合同开始时间：</td>
                            <td>{{form.contract_start_date}}</td>
                            <td style="text-align: right; color: #b6b6b6;">合同终止时间：</td>
                            <td>{{form.contract_end_date}}</td>
                        </tr>
                        <tr style="height: 50px;">
                            <td style="text-align: right; color: #b6b6b6;">合同核算单位：</td>
                            <td>{{form.contract_unit_title}}</td>
                            <td style="text-align: right; color: #b6b6b6;">服务费核算标准：</td>
                            <td>{{form.service_charge_standard_title}}</td>
                            <td style="text-align: right; color: #b6b6b6;">项目名称：</td>
                            <td>{{form.project_name}}</td>
                            <td style="text-align: right; color: #b6b6b6;">乙方名头：</td>
                            <td>{{form.partner_name}}</td>
                        </tr>
                        <tr style="height: 50px;">
                            <td style="text-align: right; color: #b6b6b6;">项目地址：</td>
                            <td>{{form.project_site}}</td>
                            <td style="text-align: right; color: #b6b6b6;">{{contract_headcount_label}}：</td>
                            <td>{{form.contract_headcount}}</td>
                            <td style="text-align: right; color: #b6b6b6;">{{contract_min_count_label}}：</td>
                            <td>{{form.contract_min_count}}</td>
                            <td style="text-align: right; color: #b6b6b6;">是否使用客户要求：</td>
                            <td>{{form.is_client_require_title}}</td>
                        </tr>
                        <tr style="height: 50px;">
                            <td style="text-align: right; color: #b6b6b6;">合同要求每日每人最多工时：</td>
                            <td>{{form.contract_max_labor_hour}}</td>
                            <td style="text-align: right; color: #b6b6b6;">合同要求每日最少工时：</td>
                            <td>{{form.contract_min_day_labor_hour}}</td>
                            <td style="text-align: right; color: #b6b6b6;">合同要求每月最少工时：</td>
                            <td>{{form.contract_min_month_labor_hour}}</td>
                        </tr>
                    </table>
                </div>

            </div>

            <div
                style="background-color: #FFFFFF; margin: 0px 40px; margin-top: 20px; padding-top: 20px; margin-bottom: 40px; padding-bottom: 20px;">

                <div
                    style="border-left: 3px #006E4B solid; height: 20px; width: 100px; margin-left: 30px; display: inline-block;">
                    <span style="margin-left: 10px; font-size: 20px; line-height: 20px; font-weight: bold;">岗位设置</span>
                </div>
                <el-button
                    style="background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B; padding-top: 8px; padding-bottom: 8px;"
                    @click="PostFind">选择岗位</el-button>
                <hr style="margin-left: 30px; margin-right: 30px; margin-top: 20px; margin-bottom: 30px;" />

                <el-row style="padding-left: 30px; padding-right: 30px;">
                    <el-col :span="12" style="margin-bottom: 10px;" v-for="(item, index) in checkProjectPostList"
                        :key="index">
                        <shift ref="shift" :projectPost="projectPostList[index]"></shift>
                    </el-col>
                </el-row>

                <div style="width: 100%; text-align: center; margin-top: 30px;">

                    <!-- <el-button type="text" @click="baici">点击打开 Dialog</el-button> -->
                    <el-button type="primary"
                        style="background-color: #006E4B; border: 1px #006E4B solid; width: 120px;" @click="baici">保存
                    </el-button>
                    <el-button type="primary"
                        style="background-color: #006E4B; border: 1px #006E4B solid; width: 120px;" @click="generate">生成解决方案
                    </el-button>
                    <el-button type="primary"
                        style="background-color: #006E4B; border: 1px #006E4B solid; width: 120px;" @click="Add">历史解决方案
                    </el-button>

                </div>
            </div>
        </div>

        <el-dialog title="选择岗位" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-checkbox-group v-model="checkProjectPostList" @change="PostChange">
                <el-checkbox v-for="item in postList" :key="item.id" :label="item.id">{{item.post_name}}</el-checkbox>
            </el-checkbox-group>
        </el-dialog>
        
        </div> 
        
        <jjfa ref="jjfa" v-show="jjfaVisible" :ruleForm="ruleForm" @return="Return"></jjfa>

        <el-dialog
            title="设置班次"
            :visible.sync="dialogVisibles"
            width="50%"
            :before-close="handleClose">
        <div>
            <el-row style="height: 506px;overflow-y:scroll">
                <el-form :model="projectPost" ref="ruleForm" label-width="160px" class="demo-ruleForm"
                    style="margin-top: 30px;">
                   <el-form-item label="班次:">
                        <el-row style="margin-bottom: 20px;" v-for="(item, index) in form.shiftCount" :key="index">
                            <el-form :model="form.shiftList[index]" ref="shiftForm" :rules="shiftRules">
                                <el-col :span="3" style="text-align: center;">班次{{index + 1}}</el-col>
                                <el-col :span="3"><span style="color: red;">*</span>工作时间</el-col>
                                <el-col :span="8">
                                    <el-row>
                                        <el-col :span="11">
                                            <el-form-item prop="start_time">
                                                <el-time-select v-model="form.shiftList[index].start_time"
                                                    :picker-options="{
                                                    start: '00:00',
                                                    step: '00:15',
                                                    end: '23:45'
                                                }" style="width: 85%;">
                                                </el-time-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="2" style="margin-left: -10px;">—</el-col>
                                        <el-col :span="11">
                                            <el-form-item prop="end_time">
                                                <el-time-select v-model="form.shiftList[index].end_time"
                                                    :picker-options="{
                                                    start: '00:00',
                                                    step: '00:15',
                                                    end: '23:45'
                                                }" style="width: 85%;">
                                                </el-time-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="2"><span style="color: red;">*</span>人数</el-col>
                                <el-col :span="4">
                                    <el-form-item prop="person_count">
                                        <el-input type="number" v-model="form.shiftList[index].person_count"
                                            style="width: 80%;">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="3">
                                    <img src="../../../assets/icon/添加.png" width="20px" @click="shiftAdd(index)"
                                        v-show="(index + 1) == form.shiftCount.length" />
                                    <img src="../../../assets/icon/减少.png" width="20px" @click="shiftRemove(index)"
                                        v-show="index != 0" />
                                </el-col>
                            </el-form>
                        </el-row>
                    </el-form-item>
                </el-form>
            </el-row>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibles = false">取 消</el-button>
            <el-button type="primary"
                        style="background-color: #006E4B; border: 1px #006E4B solid; width: 120px;" @click="Add">保存
            </el-button>
        </div>
        </el-dialog>

    </div>
</template>

<script>
    import shift from "./QyxmGl_shift.vue"
    import jjfa from "./Jjfa_add.vue"

    export default {
        components: {
            shift: shift,
            jjfa: jjfa,
        },
        data() {
            return {
                checkProjectPostList: [],

                //表单数据
                form: {
                    id: "",
                    company_id: "",
                    company_name: "",
                    organize_id: "",
                    modular_name: "",
                    organize_name:'',
                    city: "",
                    contract_code: "",
                    contract_unit_title: "",
                    service_charge_standard_title: "",
                    partner_name: "",
                    spare6: "",
                    party_title: "",
                    contract_name: "",
                    contract_start_date: "",
                    contract_end_date: "",
                    contract_unit: "",
                    service_charge_standard: "",
                    project_name: "",
                    project_site: "",
                    contract_headcount: "",
                    contract_min_count: "",
                    contract_max_labor_hour: "",
                    contract_min_day_labor_hour: "",
                    contract_min_month_labor_hour: "",
                    is_client_require: "0",
                    is_client_require_title: "",
                    projectPostList: [],
                    shiftList:[{
                        id:"",
                        shift: "班次1",
                        start_time: "",
                        end_time: "",
                        person_count: "",
                        spare1: ""
                    }],
                    shiftCount: [1],
                },

                jjfaVisible:false,

                //页面相关
                dialogVisible: false,

                dialogVisibles:false,

                //岗位数据 
                postList: [],

                //解决方案
                ruleForm:{
                   projectPostList:[], 
                },

                
                
                contract_headcount_label: "",
                contract_min_count_label: "",
				
				projectPostList: [],
            };
        },
        methods: {
            PostChange() {
                this.projectPostList = [];
                this.checkProjectPostList.forEach(item => {
                    var projectPost = {
                        id: "",
                        project_id: "",
                        post_id: "",
                        post_name: "",
                        person_count: "",
                        age_start: "",
                        age_end: "",
                        sex: "",
                        holiday_start: "",
                        holiday_end: "",
                        is_calculate: "",
                        actual_time: ""
                    };
                    this.postList.some(post => {
                        if (post.id == item) {
                            projectPost.project_id = this.form.id;
                            projectPost.post_id = post.id;
                            projectPost.post_name = post.post_name;
                            return true;
                        }
                    })
                    this.projectPostList.push(projectPost)
                })
            },
            PostFind() {
                this.dialogVisible = true;
            },

            baici(){
                this.dialogVisibles = true;
            },

            shiftAdd(e) {
                this.form.shiftCount.push(1);
                this.form.shiftList.push({
                    shift: "班次" + (e + 2),
                    start_time: "",
                    end_time: "",
                    person_count: "",
                    spare1: this.form.id
                });
            },

            shiftRemove(e) {
                this.form.shiftCount.splice(e, 1);
                this.form.shiftList.splice(e, 1);
            },

            initialize() {
                switch (this.form.contract_unit) {
                    case 3:
                        this.contract_headcount_label = "合同要求总人数";
                        this.contract_min_count_label = "合同要求当班最少人数";
                        break;
                    case 1:
                        this.contract_headcount_label = "合同要求总岗数";
                        this.contract_min_count_label = "合同要求当班最少岗数";
                        break;
                    case 2:
                        this.contract_headcount_label = "合同要求总工时数";
                        this.contract_min_count_label = "合同要求当班最少工时数";
                        break;
                };
                this.projectPostList = [];
                this.checkProjectPostList = [];
                this.form.projectPostList.forEach(item => {
                    this.checkProjectPostList.push(1);
                    this.projectPostList.push(item);
                });
            },
            //添加操作
            async Add() {
                
                var valid_flag = true;

                // this.$refs["shift"].forEach(shift => {
                //     shift.$refs["shiftForm"].forEach(shiftForm => {
                //         shiftForm.validate(valid => {
                //             valid_flag = valid;
                //         })
                //     })
                // })
                this.form.shiftList[0].spare1 = this.form.id;
                this.form.shiftList[0].shift = "班次1";
                if (valid_flag) {
                    var url = "projectPost/add";
                    // var record = this.projectPostList;
                    var record ={
                        id:this.form.id,
                        projectPostList:this.projectPostList,
                        shiftList:this.form.shiftList
                    }
                    var data = await this.$globals.AxiosPost(url, record);
                    if (data === "-2000") {
                        this.$message.error("服务器未响应！请稍后重试");
                    } else {
                        var code = data.code;
                        var data = data.data;
                        if (code === '200') {
                            this.$message.success(data);
                            this.dialogVisible = false;
                            this.dialogVisibles = false;
                            this.Return();
                        } else {
                            this.$message.warning(data);
                        }
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            },
            //生成解决方案
            async generate(){
                this.ruleForm.projectPostList = this.form.projectPostList;
                this.jjfaVisible = true;
            },

            //修改操作
            Update() {
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        alert('submit!');

                        this.$parent.$parent.Return();

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //返回
            Return() {
                this.jjfaVisible = false;
                this.$parent.Return('edit');
            },
            // shiftStart(){
                
            //     if (this.form.shiftList.length > 0) {
            //         this.shiftCount = [];
            //         this.shiftList = [];
            //         this.form.shiftList.forEach(item => {
            //             this.shiftCount.push(1);
            //             this.shiftList.push({
            //                 shift: item.shift,
            //                 start_time: item.start_time,
            //                 end_time: item.end_time,
            //                 person_count: item.person_count,
            //                 spare1: ""
            //             });
            //         })
            //     }
            // },


            
        },
        async created() {
            this.form = this.$parent.form;
            // this.shiftCount.length =this.$parent.form.shiftList.length;
            // this.shiftList = this.$parent.form.shiftList;
            // this.shiftStart()
            var postList = await this.$globals.AxiosPost("post/selectFind", {});
            this.postList = postList.data;
        }
    }
</script>

<style scoped="scoped">
    >>>.el-radio__input.is-checked .el-radio__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-radio__input.is-checked+.el-radio__label {
        color: #006E4B;
    }
</style>



// WEBPACK FOOTER //
// QyxmGl_edit.vue?b5067db2